var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',[_c('Permission',{attrs:{"mod":"business","permissions":_vm.permission}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }